import { ModelBase } from "@shoothill/core";
import { makeObservable, observable } from "mobx";
import { Validator } from "Application/Validation";

export class StudentSessionAQACertificateModel extends ModelBase<StudentSessionAQACertificateModel> {
    public studentSessionId: string | null = null;
    public description: string | null = null;
    constructor() {
        super();
        makeObservable(this, {
            description: observable,
        });
    }
}

export class StudentSessionAQACertificateModelValidator extends Validator<StudentSessionAQACertificateModel> {
    constructor() {
        super();
    }
}
